import en from 'element-plus/es/locale/lang/en';
import de from 'element-plus/es/locale/lang/de';
import es from 'element-plus/es/locale/lang/es';
import fr from 'element-plus/es/locale/lang/fr';
import he from 'element-plus/es/locale/lang/he';
import pt from 'element-plus/es/locale/lang/pt';
import ru from 'element-plus/es/locale/lang/ru';
import tr from 'element-plus/es/locale/lang/tr';
import bn from 'element-plus/es/locale/lang/bn';

import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

export function useElementLang() {
  const $i18n = useI18n();

  const langIndex = {
    en,
    de,
    es,
    fr,
    he,
    pt,
    ru,
    tr,
    bn,
  };

  //#region computed
  const elementLang = computed(() => {
    return langIndex[$i18n.locale.value];
  });
  //#endregion
  
  return { elementLang };
}